import { sendViewInsightParticipantsEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class ViewInsightParticipantsEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendViewInsightParticipantsEvent;

  constructor() {
    super();
    this.eventData = {};
  }
}
